<p-toast></p-toast>
<p-progressBar
  *ngIf="loading"
  mode="indeterminate"
  [style]="{
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '6px',
    zIndex: '9999'
  }"
>
</p-progressBar>

<div class="grupo-dashboard">
  <div class="p-fluid p-grid">
    <div class="p-col-12" style="display: flex; align-items: center">
      <img src="favicon.ico" alt="" style="width: 24px; margin-right: 10px" />
      <h3 style="font-size: 24px; font-weight: bold">Dashboard</h3>
    </div>
    <div class="p-col-12 p-grid" style="align-items: flex-start">
      <div class="p-col">
        <habil-label name="searchClass" label="Busca">
          <input
            pInputText
            class="search-lista"
            [(ngModel)]="filtro.search"
            name="pesquisa"
            placeholder="Digite o CPF/CNPJ para pesquisa..."
            [readonly]="false"
            style="max-height: 36px"
          />
        </habil-label>
      </div>
      <div class="p-col" style="max-width: 400px !important">
        <habil-label name="searchClass" label="Classificação">
          <p-multiSelect
            appendTo="body"
            [options]="classificacoesDropdown"
            [(ngModel)]="filtro.classificacoes"
            optionLabel="label"
            optionValue="value"
            name="hostHabil"
            defaultLabel="Selecione as classificações"
          >
          </p-multiSelect>
        </habil-label>
      </div>
      <div class="p-col-12 p-md-6 p-lg-2">
        <habil-label name="dtInicial" label="Data Inicial">
          <habil-date-edit
            name="dtInicial"
            [(ngModel)]="filtro.dataInicial"
            [readonly]="true"
          ></habil-date-edit>
        </habil-label>
      </div>
      <div class="p-col-12 p-md-6 p-lg-2">
        <habil-label name="dtFinal" label="Data Final">
          <habil-date-edit
            name="dtFinal"
            [(ngModel)]="filtro.dataFinal"
            [readonly]="true"
          ></habil-date-edit>
        </habil-label>
      </div>
      <div
        class="p-col-12"
        style="
          max-width: 220px !important;
          height: 100%;
          display: flex;
          align-items: flex-end;
        "
      >
        <button
          pButton
          pRippler
          class="p-button-outlined"
          icon="pi pi-search"
          label="Pesquisar"
          (click)="buscarDadosRegistros()"
        ></button>
      </div>
    </div>
    <div class="grupo-scroll-dashboard">
      <ng-container *ngFor="let data of registros">
        <div class="p-grid p-fluid p-col-12">
          <div
            class="p-col-12"
            style="
              padding: 0px !important;
              margin-left: 10px;
              margin-bottom: 5px;
            "
          >
            <h4 style="margin: 0; font-size: 18px; font-weight: bold">
              {{ data?.classificacao?.descricao }}
            </h4>
          </div>
          <div class="p-col card">
            <p class="title-card">Hoje</p>
            <p class="value-card">
              <strong>{{ data?.dia?.length || 0 }}</strong> Novos registros
            </p>
            <p class="media-card">
              <strong>{{ formatValue((data?.dia?.length || 0) / 24) }}</strong>
              Média por hora
            </p>
            <div class="button-card">
              <button
                pButton
                pRippler
                label="Detalhes"
                class="botao-acao"
                (click)="abrirDetalhes(data, 'DIA')"
              ></button>
            </div>
          </div>
          <div class="p-col card">
            <p class="title-card">Mês</p>
            <p class="value-card">
              <strong>{{ data?.mes?.length || 0 }}</strong> Novos registros
            </p>
            <p class="media-card">
              <strong>{{ formatValue((data?.mes?.length || 0) / 30) }}</strong>
              Média por dia
            </p>
            <div class="button-card">
              <button
                pButton
                pRippler
                label="Detalhes"
                (click)="abrirDetalhes(data, 'MES')"
                class="botao-acao"
              ></button>
            </div>
          </div>
          <div class="p-col card">
            <p class="title-card">Ano</p>
            <p class="value-card">
              <strong>{{ data?.ano?.length || 0 }}</strong> Novos registros
            </p>
            <p class="media-card">
              <strong>{{ formatValue((data?.ano?.length || 0) / 12) }}</strong>
              Média por mês
            </p>
            <div class="button-card">
              <button
                pButton
                pRippler
                label="Detalhes"
                class="botao-acao"
                (click)="abrirDetalhes(data, 'ANO')"
              ></button>
            </div>
          </div>
          <div class="p-col card">
            <p class="title-card">Personalizado</p>
            <p class="value-card">
              <strong>{{ data?.personalizado?.length || 0 }}</strong> Novos
              registros
            </p>
            <p class="media-card">
              <strong>{{ getMediaPersonalizada(data) }}</strong> Média por dia
            </p>
            <div class="button-card">
              <button
                pButton
                pRippler
                label="Detalhes"
                class="botao-acao"
                (click)="abrirDetalhes(data, 'PERSONALIZADO')"
              ></button>
            </div>
          </div>
          <div class="p-col-12">
            <hr />
          </div>
        </div>
      </ng-container>
    </div>
    <div class="p-col-12 p-grid" style="align-items: center">
      <div class="p-col-12" style="padding: 0">
        <hr />
      </div>
      <p
        style="
          margin: 0;
          margin-right: 40px;
          margin-left: 20px;
          font-size: 22px;
          font-weight: bold;
        "
      >
        Totais:
      </p>
      <p style="margin: 0; margin-right: 20px; font-size: 16px">
        Hoje: <strong>{{ getTotalDia() }}</strong>
      </p>
      <p style="margin: 0; margin-right: 20px; font-size: 16px">
        Mês: <strong>{{ getTotalMes() }}</strong>
      </p>
      <p style="margin: 0; margin-right: 20px; font-size: 16px">
        Ano: <strong>{{ getTotalAno() }}</strong>
      </p>
      <p style="margin: 0; margin-right: 20px; font-size: 16px">
        Período selecionado: <strong>{{ getTotalPersonalizado() }}</strong>
      </p>
    </div>
  </div>
</div>
